export default __webpack_public_path__ + "static/media/banner.2cf29c57.png";